var chunkToChildrenMap = {
	"1067": [
		406,
		6773,
		7488
	],
	"1911": [
		406,
		6773,
		7488
	],
	"3839": [
		8185,
		7852,
		1439,
		9819,
		9376,
		8325,
		6456,
		9718,
		9168,
		6515,
		6797,
		3884,
		2325,
		6535,
		9919,
		6411,
		1620,
		1931,
		1313,
		4140
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));